export default __webpack_public_path__ + "locales/en/EmptyTrashDialog.json?hash=059113ef757a103b4703da06e41a5a24";